var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8125 6C15.8125 3.34419 13.6558 1.1875 11 1.1875C8.34419 1.1875 6.1875 3.34419 6.1875 6V11.5C6.1875 14.1558 8.34419 16.3125 11 16.3125C13.6558 16.3125 15.8125 14.1558 15.8125 11.5V6ZM14.4375 6V11.5C14.4375 13.3975 12.8975 14.9375 11 14.9375C9.1025 14.9375 7.5625 13.3975 7.5625 11.5V6C7.5625 4.1025 9.1025 2.5625 11 2.5625C12.8975 2.5625 14.4375 4.1025 14.4375 6ZM8.25 21.8125H13.75C13.9323 21.8125 14.1072 21.7401 14.2361 21.6111C14.3651 21.4822 14.4375 21.3073 14.4375 21.125C14.4375 20.9427 14.3651 20.7678 14.2361 20.6389C14.1072 20.5099 13.9323 20.4375 13.75 20.4375H8.25C8.06766 20.4375 7.8928 20.5099 7.76386 20.6389C7.63493 20.7678 7.5625 20.9427 7.5625 21.125C7.5625 21.3073 7.63493 21.4822 7.76386 21.6111C7.8928 21.7401 8.06766 21.8125 8.25 21.8125Z",
    fill: "#E70000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4375 11.5C3.4375 15.6738 6.82619 19.0625 11 19.0625C15.1738 19.0625 18.5625 15.6738 18.5625 11.5C18.5625 11.3177 18.4901 11.1428 18.3611 11.0139C18.2322 10.8849 18.0573 10.8125 17.875 10.8125C17.6927 10.8125 17.5178 10.8849 17.3889 11.0139C17.2599 11.1428 17.1875 11.3177 17.1875 11.5C17.1875 14.9148 14.4148 17.6875 11 17.6875C7.58519 17.6875 4.8125 14.9148 4.8125 11.5C4.8125 11.3177 4.74007 11.1428 4.61114 11.0139C4.4822 10.8849 4.30734 10.8125 4.125 10.8125C3.94266 10.8125 3.7678 10.8849 3.63886 11.0139C3.50993 11.1428 3.4375 11.3177 3.4375 11.5Z",
    fill: "#E70000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMicrophone);
export default __webpack_public_path__ + "static/media/red-microphone.008f36d277d2f40ef36da1e7ca1598bc.svg";
export { ForwardRef as ReactComponent };